import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getStoreSettingsCollection,
    getUserBillToId,
    getUserProfileId,
    getUserShipToId,
} from "@store/Store/Context/ContextSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { CartProviderByCustomer, CartProviderByShipTo, CartProviderByUser } from "@store/Types/Settings";
import { useSelector } from "react-redux";

const useUserId = () => {
    return useSelector((state: StoreApplicationState) => {
        const settings = getStoreSettingsCollection(state);
        switch (settings.poolcorpSettings.cartProvider) {
            case CartProviderByShipTo:
                return getUserShipToId(state);
            case CartProviderByCustomer:
                return getUserBillToId(state);
            case CartProviderByUser:
            default:
                return getUserProfileId(state);
        }
    });
};

export default useUserId;
